<template>
	<div class="group-request-item">
		<div class="applicant-avatar">
			<head-image :size="56" :id="request.sendId" :name="request.sendNickName" :url="request.sendHeadImage">
			</head-image>
		</div>
		<div class="request-info">
			<div class="applicant-name">{{ request.sendNickName }}</div>
			<div class="info-text">
				<span v-if="request.remark">{{ request.remark }}</span>
				<span v-else-if="isSender">申请加入 {{ request.groupName }}</span>
				<span v-else>申请加入群聊</span>
			</div>
		</div>
		<div class="btn-group">
			<el-button v-if="!isSender && isPending" type="danger" size="mini" @click="onReject">拒绝</el-button>
			<el-button v-if="!isSender && isPending" type="primary" size="mini" @click="onApprove">同意</el-button>
			<el-button v-if="isSender && isPending" type="danger" size="mini" @click="onRecall">撤回</el-button>
			<span v-if="!isPending" class="status-tag">{{ statusText }}</span>
		</div>

		<el-dialog title="申请详情" :visible.sync="showDialog" width="400px" append-to-body>
			<div class="dialog-body">
				<div class="dialog-row">
					<span class="label">申请人：</span>
					<span>{{ request.sendNickName }}</span>
				</div>
				<div class="dialog-row">
					<span class="label">目标群聊：</span>
					<span>{{ request.groupName }}</span>
				</div>
				<div class="dialog-row" v-if="request.groupQq">
					<span class="label">群号：</span>
					<span>{{ request.groupQq }}</span>
				</div>
				<div class="dialog-row" v-if="request.remark">
					<span class="label">申请备注：</span>
					<span>{{ request.remark }}</span>
				</div>
			</div>
			<span slot="footer" v-if="isPending">
				<el-button v-if="!isSender" @click="onReject">拒绝</el-button>
				<el-button v-if="!isSender" type="primary" @click="onApprove">同意</el-button>
				<el-button v-if="isSender" type="danger" @click="onRecall">撤回</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';

export default {
	name: 'groupRequestItem',
	components: { HeadImage },
	props: {
		request: {
			type: Object
		}
	},
	data() {
		return {
			showDialog: false
		};
	},
	methods: {
		onApprove() {
			this.$http({ url: '/group/request/approve?id=' + this.request.id, method: 'post' }).then(() => {
				this.groupRequestStore.removeRequest(this.request.id);
				this.showDialog = false;
				this.$message.success('已同意申请');
			});
		},
		onReject() {
			this.$http({ url: '/group/request/reject?id=' + this.request.id, method: 'post' }).then(() => {
				this.groupRequestStore.removeRequest(this.request.id);
				this.showDialog = false;
				this.$message.success('已拒绝申请');
			});
		},
		onRecall() {
			this.$http({ url: '/group/request/recall?id=' + this.request.id, method: 'post' }).then(() => {
				this.groupRequestStore.removeRequest(this.request.id);
				this.showDialog = false;
				this.$message.success('已撤回申请');
			});
		}
	},
	computed: {
		mine() {
			return this.userStore.userInfo;
		},
		isSender() {
			return this.request.sendId == this.mine.id;
		},
		isPending() {
			return this.request.status === this.$enums.REQUEST_STATUS.PENDING;
		},
		statusText() {
			const s = this.request.status;
			if (s === this.$enums.REQUEST_STATUS.APPROVED) return '已同意';
			if (s === this.$enums.REQUEST_STATUS.REJECTE) return '已拒绝';
			if (s === 4) return '已撤回';
			if (s === 5) return '已过期';
			return '';
		}
	}
}
</script>

<style scope lang="scss">
.group-request-item {
	display: flex;
	position: relative;
	align-items: center;
	cursor: pointer;
	margin: 0 30px;
	padding: 10px;
	border-bottom: 1px solid #eee;

	&:hover {
		background-color: var(--im-background-active);
	}

	.request-info {
		margin: 0 15px;
		flex: 3;
		display: flex;
		flex-direction: column;
		overflow: hidden;

		.applicant-name {
			font-weight: 600;
			font-size: 16px;
			line-height: 30px;
		}

		.info-text {
			font-size: 14px;
			line-height: 20px;
			color: var(--im-text-color-light);
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
	}

	.btn-group {
		display: flex;
		align-items: center;
		gap: 8px;

		.status-tag {
			font-size: 13px;
			color: var(--im-text-color-light);
		}
	}

	.dialog-body {
		.dialog-row {
			display: flex;
			margin-bottom: 12px;
			font-size: 14px;

			.label {
				color: var(--im-text-color-light);
				min-width: 80px;
			}
		}
	}
}
</style>
